
import {
  Vue,
  Component,
  Prop,
  Watch,
} from 'vue-property-decorator';
import { State } from 'vuex-class';
import {
  Form,
  FormItem,
  Input,
  Cascader,
  Select,
  Option,
} from 'element-ui';
import QuesApi from '@/api/question';
import api from '@/api/asset';
import Util from '@/libs/util';

@Component({
  components: {
    Form,
    FormItem,
    Input,
    Cascader,
    Select,
    Option,
  },
})
export default class SearchForm extends Vue {
  @State((state => state.asset.category.listFlag)) listFlag!: boolean;

  @Prop() title!: string;

  private form: any = {
    title: '',
    categoryId: '',
    courseType: [],
    id: [],
  };

  private options: { [key: string]: Array<object> } = {
    categoryIdOpts: [],
    tidOpts: [],
    cidOpts: [],
  };

  public $refs!: {
    form: Form,
  };

  created() {
    this.getCourseType();
    this.getCategoryList();
  }

  setTitle(val: string) {
    this.form.title = val;
  }

  getFormData() {
    return {
      title: this.form.title,
      categoryId: this.form.categoryId,
      id: this.form.id[1] || '',
    };
  }

  getCourseType() {
    QuesApi.getCourseType().then((res: any) => {
      this.options.tidOpts = Util.CompTreeNode(res, 'children');
    });
  }

  getCategoryList() {
    api.getCategoryList().then((res: any) => {
      this.options.categoryIdOpts = res;
    });
  }

  getCourseByType(tid: string) {
    QuesApi.getCourseByType(tid).then((res: any) => {
      this.options.cidOpts = res.map((em: any) => ({ id: em.id, children: em.chapters, name: `${em.name} ${em.version ? em.version : ''}` }));
    });
  }

  handleTidChange(v: Array<any>) {
    if (v.length > 0) {
      // (this.$refs.form as Form).clearValidate();
      this.getCourseByType(v[1]);
    } else {
      this.options.cidOpts = [];
    }
  }

  /**
   * @author liangyongmou
   * @desc 清空事件
   */
  handleClear() {
    this.$refs.form.resetFields();
    this.options.cidOpts = [];
  }

  @Watch('listFlag')
  watchListFlag() {
    this.getCategoryList();
  }
}
